export default __webpack_public_path__ + "static/TripReview-7753cdd706228decad8a6dc3d3225ec9.png";